import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import styled from 'styled-components';

import useUser from 'hooks/useUser';

import { Sidebar } from './_components/sidebar/sidebar.component';

export const AdminLayout = () => {
  const { currentUser } = useUser();

  if (currentUser?.isAdmin === false) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="container-fluid">
      <div className="row flex-nowrap">
        <Sidebar />
        <Main className="col py-3">
          {/* <Header /> */}
          <Outlet />
        </Main>
      </div>
    </div>
  );
};

const Main = styled.div`
  max-height: 100vh;
  overflow-y: auto;
  background-color: ${(props) => props.theme.color.bg.muted};
`;
